import { ConfigurationData } from '@/types/crm/configuration/configuration';
import { removeEmptyArraysFromNestedObject } from '@/lib/utils/object';
export function prepareConfigurationDataForInsert(
  data: ConfigurationData
): ConfigurationData {
  const strippedUndefinedOptionsForParameters: ConfigurationData = {
    ...data,
    parameter: removeEmptyArraysFromNestedObject(data.parameter),
  };
  return strippedUndefinedOptionsForParameters;
}
